import type { IBonusBannerData } from './banners';
import type { IGroupFilter } from './filters';
import type { IStrapiImage } from './strapiImage';

export enum EBonusType {
  Cashback = 'Cashback',
  Event = 'Event',
  Exclusive = 'Exclusive',
  Reload = 'Reload',
  Telegram = 'Telegram',
  Vip = 'VIP',
  Welcome = 'Welcome',
  SpecialEvent = 'SpecialEvent',
  Achievements = 'Achievements',
}

export enum EBonusStatus {
  active = 'active',
  locked = 'locked',
  done = 'done',
  missed = 'missed',
}

export enum EBonusTabTypesExtension {
  All = 'all',
  Welcome = 'Welcome',
}

export type TBonusLabelColor = 'green' | 'blue' | 'yellow' | 'pink' | 'grey' | '';

export type TBonusTab = EBonusType | EBonusTabTypesExtension;

export interface IBonusDataEssential {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  publishedAt?: Date;
  descriptionText?: string;
  rulesText?: string;
  bonusCode?: string;
  groupActive?: string;
  groupLocked?: string;
  groupRecieved?: string;
  title: string;
  stageOnly: boolean;
  position: number;
  bonusId: string;
  excludedDays?: string;
  includedDays?: string;
  startDate?: Date;
  finishDate?: Date;
  linkAction?: any;
  descriptionModalText?: string;
  termsModalText?: string;
  hideForGroups?: string;
  hideForGuests?: boolean;
  recievedBonusCustomIcon?: IStrapiImage;
  lockedBonusCustomIcon?: IStrapiImage;
  offer: string;
  getBonusTitle?: string;
  groupFilter?: IGroupFilter;
  cashierMinDepositTitle?: string;
  cashierMinDepositValue?: string;
  cashierBonusBanner?: IStrapiImage;
  groupMissed?: string;
  missedBonusCustomIcon?: IStrapiImage;
  recievedBonusText?: string;
  lockedBonusText?: string;
  missedBonusText?: string;
  bannerCardFront: IStrapiImage;
  bannerCardBack?: IStrapiImage;
  customLabelText?: string;
  tablesWithHeading: {
    tableTitle?: string;
    tableItem: {
      rawTitle: string;
      value: string;
      valueAdditional?: string;
    }[];
  }[];
  showInCashierModal?: boolean;
  status?: EBonusStatus;
  locale: string;
  availableUntil?: any;
  crmAutoCampaignId?: string;
  showForUsers?: string;
  bonusTitleForBO?: string;
  additionalLabel?: string;
  additionalLabelColor?: string;
}

export interface IBonusData extends IBonusDataEssential {
  bonusType: EBonusType;
  nextActiveDate: Date | null;
}

export interface IBonusDataFromStrapi extends IBonusDataEssential {
  bonusType: { bonusType: EBonusType };
}

export interface IBonusesStrapiResponse {
  data: IBonusDataFromStrapi[];
}

export interface IBonusTabsDataEssential {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  publishedAt?: Date;
  position: number;
  title: string;
  labelColor: TBonusLabelColor;
  icon: IStrapiImage;
  labelTitle: string;
  locale: string;
}

export interface IBonusTabData extends IBonusTabsDataEssential {
  bonusType: EBonusType;
}

export interface IBonusTabDataFromStrapi extends IBonusTabsDataEssential {
  bonusType: { bonusType: EBonusType };
}

export interface IBonusTabsStrapiResponse {
  data: IBonusTabDataFromStrapi[];
}

export interface IBonusesPageDataStrapiResponse {
  bonusesData: IBonusDataFromStrapi[];
  bonusesTabs: IBonusTabDataFromStrapi[];
  bonusesBanners: IBonusBannerData[];
}
